import { UsagePaywall } from './usage-paywall';
import { LicensedDone } from './licensed-done';
import { IntentSelector } from './intent-selector';
import { LicensedConfirmation } from './licensed-confirmation';
import { CheckoutStep } from './checkout-step';

import { useFreemiumGateFlow } from '../hooks/use-freemium-gate-flow';

import { getFreemiumTierConfig } from '@shared';

interface FreemiumPaywallFlowProps {
  clientId: string;
  clientFirstName: string;
  onExit: () => void;
}

export function FreemiumPaywallFlow({
  clientId,
  clientFirstName,
  onExit,
}: FreemiumPaywallFlowProps) {
  const {
    step,
    intent,
    selectedTier,
    clientSecret,
    setIntent,
    continueToPaywall,
    goToPaywall,
    goToIntent,
    chooseTier,
    payLicensedNow,
    waitForOutreach,
    isPending,
  } = useFreemiumGateFlow(clientId);

  const selectedTierConfig = selectedTier ? getFreemiumTierConfig(selectedTier) : null;

  return (
    <>
      {step === 'intent' && (
        <IntentSelector
          clientFirstName={clientFirstName}
          value={intent}
          onChange={setIntent}
          onContinue={continueToPaywall}
          onBack={onExit}
        />
      )}

      {(step === 'paywall' || step === 'licensedConfirm') && (
        <UsagePaywall
          clientFirstName={clientFirstName}
          onSelectTier={chooseTier}
          onBack={goToIntent}
          isPending={isPending}
        />
      )}

      {selectedTierConfig && (
        <LicensedConfirmation
          open={step === 'licensedConfirm'}
          tierName={selectedTierConfig.name}
          priceUsd={selectedTierConfig.priceUsd}
          onPayNow={payLicensedNow}
          onWait={waitForOutreach}
          onOpenChange={next => {
            if (!next) goToPaywall();
          }}
          isPending={isPending}
        />
      )}

      {step === 'checkout' &&
        (clientSecret && selectedTierConfig ? (
          <CheckoutStep
            config={selectedTierConfig}
            clientFirstName={clientFirstName}
            clientSecret={clientSecret}
            onBack={goToPaywall}
          />
        ) : (
          <div className="flex flex-col items-center gap-4 py-16">
            <div className="border-primary size-10 animate-spin rounded-full border-4 border-t-transparent" />
            <p className="text-foreground font-medium">Preparing secure checkout…</p>
          </div>
        ))}

      {step === 'licensedDone' && <LicensedDone clientFirstName={clientFirstName} />}
    </>
  );
}
